import React from 'react';


export default class KeyValPair extends React.Component {

    static defaultProps = {

        val: '--',
        condensed: false,
    }

    render () {
        let {_key, val, condensed} = this.props;

        // safeguard to stop objects that were crashing the system.
        const isReactElement = (obj) => obj && obj.$$typeof === Symbol.for('react.element');

        if (typeof val === 'object' && !isReactElement(val)) val = '--'

        const columnClassed = `${condensed ? 'm-0 py-1' :''}`

        return (
            <div data-testid={this.props['data-testid']} className={`block columns key-val ${this.props.striped ? 'striped' : ''}`}>
                <div className={`column is-one-third ${columnClassed}`}>
                    <p className="m-0 is-size-7 has-text-weight-light">{_key}</p>
                </div>
                <div className={`column ${columnClassed}`}>
                    <p>{val}</p>
                </div>
            </div>
        )
    }

}